
import Lamp1 from "../../../assets/filled/Lamp1.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Lamp1Icon({ className, dataTestid = "Lamp1Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Lamp1 data-testid={dataTestid} className={classes} {...rest} />
  );
}
